import PredicateDatepicker from './predicate-datepicker.vue';
export default PredicateDatepicker;
